"use strict";

/* eslint-disable no-console */
var _defineProperty = require("/opt/webapp/node_modules/.pnpm/next@14.2.15_@babel+core@7.29.0_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/compiled/@babel/runtime/helpers/defineProperty.js");
var _require = require("lodash"),
  merge = _require.merge,
  clone = _require.clone,
  get = _require.get,
  has = _require.has;
var flat = require("flat");
var unflatten = flat.unflatten;
function toJSON(key, value) {
  /*
  * JSON.parse will handle data like "true", "True", "false", "False", "1", "0"
  * (that's why we use .toLowerCase() before)
  * and convert them to Boolean or Number
  * Other strings will throw an exception and will be left as it is.
  */
  try {
    return _defineProperty({}, key, JSON.parse(value.toLowerCase()));
  } catch (e) {
    return _defineProperty({}, key, value);
  }
}
function parse(configData) {
  var flattedData = flat(configData);
  var parsedConfig = Object.keys(flattedData).reduce(function (acc, key) {
    return Object.assign(acc, toJSON(key, flattedData[key]));
  }, {});
  return unflatten(parsedConfig);
}
function mergeWithTypeCoercion(config, data) {
  return parse(merge({}, config, data));
}
function Config(data) {
  if (!(this instanceof Config)) {
    return new Config(data);
  }
  this.configStore = mergeWithTypeCoercion(this.configStore, data);
}
Config.prototype.add = function addData(data) {
  this.configStore = mergeWithTypeCoercion(this.configStore, data);
  return this;
};
Config.prototype.env = function addEnvData() {
  var processEnv = unflatten(process && process.env);
  this.configStore = mergeWithTypeCoercion(this.configStore, processEnv);
  return this;
};
Config.prototype.argv = function addCommandLineArgs(argv) {
  argv = argv || process && process.argv;
  if (argv) {
    var appArgs = argv.slice(2).reduce(function (args, arg) {
      var argData = arg.split("=");
      if (argData.length === 2) {
        args[argData[0]] = argData[1];
      }
      return args;
    }, {});
    this.configStore = mergeWithTypeCoercion(this.configStore, unflatten(appArgs));
  }
  return this;
};
Config.prototype.locale = function locale(overrideLocal) {
  var newVar = this.get();
  delete newVar.override;
  return new Config(merge({}, newVar, this.get(["override", overrideLocal])));
};
Config.prototype.file = function addFile(configFilename) {
  if (typeof window === "undefined" || process.env.NODE_ENV === "test") {
    var fs = require("fs");
    try {
      this.configStore = mergeWithTypeCoercion(this.configStore, JSON.parse(fs.readFileSync(configFilename)));
    } catch (e) {
      console.error("Couldn't add config data from file", configFilename);
    }
  }
  return this;
};
Config.prototype.get = function getConfigValue(configKey, locale) {
  var overrideKey = "override.".concat(locale, ".").concat(configKey);
  if (locale && has(this.configStore, overrideKey)) {
    return get(this.configStore, overrideKey);
  }
  return configKey ? get(this.configStore, configKey) : clone(this.configStore);
};
Config.prototype.set = function setConfigValue(configKey, configValue) {
  var o = {};
  o[configKey] = configValue;
  this.configStore = mergeWithTypeCoercion(this.configStore, unflatten(o));
  return this;
};
Config.prototype.hydrate = function hydrate(windowRef) {
  if (global.window && global.window.clubmed) {
    this.configStore = mergeWithTypeCoercion(this.configStore, global.window.clubmed[windowRef]);
  }
  return this;
};
Config.prototype.dehydrate = function dehydrate() {
  return JSON.stringify(this.get());
};
module.exports = Config;